<!--  FITvSelect use for static options list and type search function -->
<template>
  <b-row class="my-3" align-v="center">
    <b-col :sm="labelWidth" class="text-left">
      <label class="mb-0 align-middle">{{this.label}}</label>
    </b-col>
    <b-col :sm="inputWidth">
      <v-select :value="this.value" :options="this.options" :disabled='this.disabled' :placeholder="this.placeholder" @input='change($event)'></v-select>
    </b-col>
  </b-row>
</template>
<script type="text/javascript">
/* eslint-disable */
import Vue from 'vue'
import vSelect from 'vue-select'
// import { API, APIList } from '@/api'


export default {
  name: 'FITvSelect',
  components: { vSelect },
  props: {
    label: String,
    options: {
      type: Array,
    },
    width: Number,
    disabled: Boolean,
    placeholder: String,
    value: [String, Object],
  },
  data() {
    return {
      inputWidth: this.width,
      optionList:[],
    }
  },
  created(){
 
  },
  mounted() {
    this.labelCheck(this.label);
  },
  
  computed: {
    labelWidth() {
      return 12 - this.inputWidth;
    }
  },
  methods: {
    labelCheck(label) {
      if (!label) {
        this.inputWidth = 12;
      }
    },
    change(event) {
      this.$emit('input', event);
    }
  }
}

</script>
<style type="text/css">
</style>



// WEBPACK FOOTER //
// src/components/Form/FITvSelect.vue